import { render } from "./TenetForm.vue?vue&type=template&id=40b51910"
import script from "./TenetForm.vue?vue&type=script&lang=ts"
export * from "./TenetForm.vue?vue&type=script&lang=ts"
script.render = render

export default script